import axios, { AxiosResponse } from 'axios';
import Config from '@/config';
import users from '@/store/modules/users';

export default class ClientService {
  public async createClient(body: any): Promise<AxiosResponse> {
    let response: AxiosResponse;

    try {
      response = await axios.post(Config.baseApiUrl + '/client/', body, {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async editClient(body: any): Promise<AxiosResponse> {
    let response: AxiosResponse;

    try {
      response = await axios.put(
        Config.baseApiUrl + '/client/' + body.clientId,
        body.data,
        {
          headers: {
            auth: `${users.userToken}`,
          },
        },
      );

      return response;
    } catch (error) {
      return error;
    }
  }

  public async deleteClient(body: any): Promise<AxiosResponse> {
    let response: AxiosResponse;

    try {
      response = await axios.delete(
        Config.baseApiUrl + '/client/' + body.clientId,
        {
          headers: {
            auth: `${users.userToken}`,
          },
        },
      );

      return response;
    } catch (error) {
      return error;
    }
  }

  public async setSecurity(body: any): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.post(
        Config.baseApiUrl + '/client/set-security',
        body,
        {
          headers: {
            auth: `${users.userToken}`,
          },
        },
      );

      return response;
    } catch (error) {
      return error;
    }
  }

  public async getClients(): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.get(Config.baseApiUrl + '/client', {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async getClient(payload: any): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.get(`${Config.baseApiUrl}/client/${payload.id}`, {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async getStatusSummary(): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.get(Config.baseApiUrl + '/status', {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async getHoldedClients(): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.get(Config.baseApiUrl + '/client/holded', {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async getPendingClients(): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
      response = await axios.get(Config.baseApiUrl + '/client/pending', {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response;
    } catch (error) {
      return error;
    }
  }

  public async createHoldedContact(body: any) {
    let response: AxiosResponse;
    try {
      response = await axios.post(
        Config.baseApiUrl + '/client/holded/create',
        body,
        {
          headers: {
            auth: `${users.userToken}`,
          },
        },
      );

      return response;
    } catch (error) {
      return error;
    }
  }

  public async generateInvoice(body: any) {
    let response: AxiosResponse;
    try {
      response = await axios.post(
        Config.baseApiUrl + '/client/holded/invoice',
        body,
        {
          headers: {
            auth: `${users.userToken}`,
          },
        },
      );

      return response;
    } catch (error) {
      return error;
    }
  }

  public async retrieveReports() {
    let response: AxiosResponse;
    try {
      response = await axios.get(Config.baseApiUrl + '/client/glossary', {
        headers: {
          auth: `${users.userToken}`,
        },
      });

      return response.data;
    } catch (error) {
      return error;
    }
  }
}
